import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, Button, Space, Card } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

// DataSet 查詢條件編輯 Modal
const DataSetQueryConditionModal = ({
  visible,
  onCancel,
  editingConditionGroup,
  conditionGroupForm,
  dataSetColumns,
  processVariables,
  onSave,
  onEditCondition,
  onAddCondition,
  onDeleteCondition,
  t
}) => {
  // 當模態框打開時，設置表單的初始值
  useEffect(() => {
    if (visible && editingConditionGroup && conditionGroupForm) {
      conditionGroupForm.setFieldsValue({
        relation: editingConditionGroup.relation || 'and'
      });
    }
  }, [visible, editingConditionGroup, conditionGroupForm]);

  const currentConditions = editingConditionGroup?.conditions || [];
  
  return (
    <Modal
      title={editingConditionGroup && editingConditionGroup.groupIndex === -1 ? 
        t('workflowDesigner.dataSet.addQueryConditionGroup') : 
        t('workflowDesigner.dataSet.editQueryConditionGroup')
      }
      open={visible}
      onCancel={onCancel}
      width={800}
      footer={null}
      destroyOnClose
    >
      <Form
        form={conditionGroupForm}
        layout="vertical"
        onFinish={onSave}
      >
        <Form.Item
          label={t('workflowDesigner.dataSet.conditionRelation')}
          name="relation"
          rules={[{ required: true, message: t('workflowDesigner.dataSet.conditionRelationPlaceholder') }]}
        >
          <Select>
            <Select.Option value="and">{t('workflowDesigner.dataSet.and')} - {t('workflowDesigner.dataSet.andDescription')}</Select.Option>
            <Select.Option value="or">{t('workflowDesigner.dataSet.or')} - {t('workflowDesigner.dataSet.orDescription')}</Select.Option>
          </Select>
        </Form.Item>
        
        <Form.Item label={t('workflowDesigner.dataSet.queryConditions')}>
          <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #d9d9d9', borderRadius: '6px', padding: '8px' }}>
            {currentConditions.map((condition, condIndex) => (
              <div key={condition.id} style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                marginBottom: '8px',
                padding: '8px',
                backgroundColor: '#f5f5f5',
                borderRadius: '4px'
              }}>
                <div style={{ flex: 1, fontSize: '14px' }}>
                  <strong>{condition.fieldName}</strong> {condition.operator} <strong>{condition.value}</strong>
                  {condition.label && <div style={{ fontSize: '12px', color: '#666' }}>{condition.label}</div>}
                </div>
                <Button 
                  type="text" 
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => onEditCondition(condition, condIndex)}
                />
                <Button 
                  type="text" 
                  danger 
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => onDeleteCondition(condIndex)}
                />
              </div>
            ))}
            
            {(!currentConditions || currentConditions.length === 0) && (
              <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                {t('workflowDesigner.dataSet.noQueryConditions')}
              </div>
            )}
            
            <Button 
              type="dashed" 
              onClick={onAddCondition}
              style={{ width: '100%' }}
            >
              {t('workflowDesigner.dataSet.addCondition')}
            </Button>
          </div>
        </Form.Item>
        
        <div style={{ textAlign: 'right' }}>
          <Space>
            <Button onClick={onCancel}>
              {t('workflowDesigner.dataSet.cancel')}
            </Button>
            <Button type="primary" htmlType="submit">
              {editingConditionGroup && editingConditionGroup.groupIndex === -1 ? t('workflowDesigner.dataSet.add') : t('workflowDesigner.dataSet.update')}
            </Button>
          </Space>
        </div>
      </Form>
    </Modal>
  );
};

export default DataSetQueryConditionModal;
